module.exports = __webpack_public_path__ + "img/donante-mishmash.009be43d.png";